// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyCardFinderRequestSearchResponse } from './pharmacyCardFinderRequestSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyV1PharmacyV1CardFinderRequestSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': PharmacyCardFinderRequestSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyV1PharmacyV1CardFinderRequestSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "PharmacyCardFinderRequestSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyV1PharmacyV1CardFinderRequestSearchDefaultResponse.attributeTypeMap;
    }
}
